import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IWorkoutSuccessPredictor, TSuccessPredictorApiResponse } from './types';

export interface ISuccessPredictorState {
  loading: boolean;
  predictions: IWorkoutSuccessPredictor[];
}

export const initialState: ISuccessPredictorState = {
  loading: true,
  predictions: [],
};

export const statePropName = 'successPredictor';

const successPredictorSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initSuccessPredictor(state) {
      return {
        ...initialState,
      };
    },
    successPredictorReady(state) {
      state.loading = false;
    },
    loadSuccessPredictor(state, action: PayloadAction<number[]>) {
      // No state change needed for this action
    },
    successPredictorResult(state, action: PayloadAction<TSuccessPredictorApiResponse>) {
      state.predictions = action.payload;
    },
  },
});

export const SuccessPredictorActions = successPredictorSlice.actions;
export default successPredictorSlice.reducer;
